<template>
<div>
    <div class='item-actions icon-text-buttons flex-container'>
        <p-button type="default" size="sm" outline :disabled="loading" class="stacked flex-child" @click="sendAction('sendLayouts')">
            <b-icon icon="columns"/>
            <span>{{ $t('infopoints.actionBtn.layout') }}</span>
        </p-button>
        <p-button type="default" size="sm" outline :disabled="loading" class="stacked flex-child" @click="sendAction('sendDepartures')">
            <b-icon icon="justify"/>
            <span>{{ $t('infopoints.actionBtn.timetables') }}</span>
        </p-button>
        <p-button type="default" size="sm" outline :disabled="loading" class="stacked flex-child" @click="sendAction('sendAnnouncements')">
            <b-icon icon="info-square"/>
            <span>{{ $t('infopoints.actionBtn.infos') }}</span>
        </p-button>
        <p-button type="default" size="sm" outline :disabled="loading" class="stacked flex-child" @click="sendRebootRequest">
            <b-icon icon="bootstrap-reboot"/>
           <span>{{ $t('infopoints.actionBtn.reboot') }}</span>
        </p-button>       
    </div>
    <RequestInfo :ok="ok" :error="error" :loader="loading" />
</div>
</template>

<script>

export default {
    props: ['item'], 
    data() {
        return {
            ok: false,
            error: false,
            loading: false
        }
    },
    computed: {
        infopoint() {
            return this.item;
            //return this.$store.state.infopoint.selectedInfopoint;
        }
    },
    watch: {
       infopoint(){
            this.ok = this.error = this.loading = false;
       } 
    },
   
    methods: {
        sendAction(action) {
            this.ok = this.error = false;
            this.loading = true;
            const self = this;
            this.$traveller_http.post('/traveller/restui/infopoint/'+ action, [ this.infopoint.id ])
            .then( () => {
                setTimeout(() => { self.ok = true; self.loading = false; }, 1000);               
            })
            .catch( () => {
                 setTimeout(() => { self.error = true; self.loading = false;}, 1000);          
            }) 
            .finally(); 
         
        },
        sendRebootRequest(){
            this.ok = this.error = false;
            this.loading = true;
            const self = this;
            
            this.$traveller_http.get('/traveller/restui/infopoint/sendRebootRequest', { params: { "id": this.infopoint.id } })
            .then( () => {
                setTimeout(() => { self.ok = true; self.loading = false; }, 1000);               
            })
            .catch( () => {
                 setTimeout(() => { self.error = true; self.loading = false;}, 1000);          
            }) 
            .finally(); 
            
        }

    }
}

</script>

<style scoped lang="scss" >

        .flex-container {
            display: flex;
            flex-direction: column;
            margin: auto;
            align-items: center;

            .flex-child {
                flex: 1;
                width: 200px;
            }
        }

</style>
